import React, { useState, useRef, useEffect } from "react";
import { FiImage } from "react-icons/fi";
import { Stage, Layer, Circle } from "react-konva";
import CroppedImageFromFile from "../../../../../components/formComponents/CroppedImage";
import DeleteIcon from "../../../../../components/DeleteIcon";
import { getImageUrls } from "../../../../../utils/helpers";
import ImgOptimized from "../../../../../components/ImgOptimized";
import PopupWrapper from "../../../../../components/PopupWrapper";

const FloorMapUpload = ({
  floorMap,
  onSelectArea,
  coordinates,
  isImageAreaSelection,
  heading,
  btnText,
  isLargeArea = false,
  isMultiple = false,
  allFloorMaps = [],
  selectedKeyPlanIdx,
}) => {
  isMultiple &&
    console.log("------FLOORMAPUPLOAD----", {
      floorMap,
      coordinates,
      allFloorMaps,
      selectedKeyPlanIdx,
    });
  const [isOpen, setIsOpen] = useState(false);
  const [stageSize, setStageSize] = useState({ width: 0, height: 0 });
  const [originalImageSize, setOriginalImageSize] = useState({
    width: 0,
    height: 0,
  });
  const [scaleFactors, setScaleFactors] = useState({ x: 1, y: 1 });
  const imageRef = useRef(null);
  const [floorMapUrl, setFloorMapUrl] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const [pickerOpen, setPickerOpen] = useState(false);
  const [selectedFloorIndex, setSelectedFloorIndex] = useState(null);

  // Fixed container size for display
  const CONTAINER_WIDTH = 600;
  const CONTAINER_HEIGHT = 400;

  // Circle state
  console.log("FloorMap", floorMap, coordinates);
  const [circlePos, setCirclePos] = useState({ x: 100, y: 100 });
  const [circleRadius, setCircleRadius] = useState(100);
  const [isDragging, setIsDragging] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  const openPicker = () => setPickerOpen(true);
  const closePicker = () => setPickerOpen(false);

  const callOnSelect = (payload) => {
    if (!onSelectArea) return;
    if (isMultiple) onSelectArea(payload, selectedFloorIndex);
    else onSelectArea(payload);
  };

  useEffect(() => {
    // if (floorMap && floorMap instanceof File) {
    //   const url = URL.createObjectURL(floorMap);
    //   setFloorMapUrl(url);

    //   return () => {
    //     URL.revokeObjectURL(url);
    //   };
    // }
    // return;
    floorMap &&
      setFloorMapUrl(
        getImageUrls(
          Array.isArray(floorMap) ? floorMap : [floorMap],
          true,
          true,
        )?.[0],
      );
  }, [floorMap]);

  useEffect(() => {
    // When coordinates are provided (update scenario), convert original coordinates to scaled display coordinates
    if (
      coordinates &&
      Object.keys(coordinates).length > 0 &&
      scaleFactors.x !== 1
    ) {
      if (coordinates.position) {
        setCirclePos({
          x: (coordinates.position.x || 100) * scaleFactors.x,
          y: (coordinates.position.y || 100) * scaleFactors.y,
        });
      }
      if (coordinates.radius) {
        setCircleRadius(
          (coordinates.radius || 50) * Math.min(scaleFactors.x, scaleFactors.y),
        );
      }
    }
  }, [coordinates, scaleFactors]);

  const handleCircleDragStart = () => {
    setIsDragging(true);
  };

  const handleCircleDragEnd = (e) => {
    setCirclePos({
      x: e.target.x(),
      y: e.target.y(),
    });
    setIsDragging(false);
  };

  const handleSaveSelection = () => {
    // Convert scaled coordinates back to original image coordinates
    const originalX = circlePos.x / scaleFactors.x;
    const originalY = circlePos.y / scaleFactors.y;
    const originalRadius =
      circleRadius / Math.min(scaleFactors.x, scaleFactors.y);

    console.log("Saving area:", {
      scaled: { circlePos, circleRadius },
      original: { x: originalX, y: originalY, radius: originalRadius },
    });
    const payload = {
      position: { x: originalX, y: originalY },
      radius: originalRadius,
      areaData: {
        x: originalX - originalRadius,
        y: originalY - originalRadius,
        width: originalRadius * 2,
        height: originalRadius * 2,
      },
    };

    callOnSelect(payload);
    onClose();
  };

  const handleStageClick = (e) => {
    // Only move circle if clicking on the stage background (not the circle itself)
    if (e.target === e.target.getStage()) {
      const pos = e.target.getStage().getPointerPosition();
      setCirclePos({
        x: pos.x,
        y: pos.y,
      });
    }
  };
  // console.log(imageRef.current, "imageRef in FloorMapUpload");
  // if(!floorMap?.[0] ) return null;

  // No longer need scroll centering since image fits in fixed container
  return (
    <>
      <div className="border-2 border-dashed border-gray-300 rounded-md p-2 text-center bg-gray-50 dark:bg-gray-700">
        {coordinates && Object.keys(coordinates)?.length > 0 && floorMapUrl ? (
          <div className="flex items-center justify-center h-full relative">
            <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-teal-500 ">
              <CroppedImageFromFile
                areaData={coordinates?.areaData}
                position={coordinates?.position}
                imageFile={floorMapUrl}
                radius={coordinates?.radius}
                isFloorMAp={true}
              />

              <DeleteIcon
                className="absolute top-0 right-0 "
                onClick={() => callOnSelect({})}
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-2">
            <FiImage className="w-10 h-10 text-gray-400" />
            <p className="text-gray-500 italic ">
              {floorMap
                ? ` ${isImageAreaSelection ? (heading ? heading : " Now you can select your image") : "Now you can select your key plan"}`
                : "Upload floor map first"}
            </p>
            <button
              className={`w-full py-2 px-4 rounded capitalize ${
                (isMultiple ? allFloorMaps.length != 0 : !!floorMap)
                  ? "bg-gray-200 hover:bg-gray-300 cursor-pointer"
                  : "bg-gray-200 opacity-50 cursor-not-allowed"
              }`}
              disabled={isMultiple ? allFloorMaps.length == 0 : !floorMap}
              onClick={isMultiple ? openPicker : onOpen}
            >
              {isImageAreaSelection
                ? btnText
                  ? btnText
                  : "Select focus area"
                : "Select key plan"}
            </button>
          </div>
        )}
      </div>

      {/* Picker modal for multiple floor maps (uses PopupWrapper) */}
      {pickerOpen && (
        <PopupWrapper
          onClose={closePicker}
          width="w-[400px]"
          heading="Choose a floor map"
          isWidthAuto
          isShowAction={false}
        >
          <div className="grid grid-cols-2 gap-3 max-h-72 overflow-auto">
            {allFloorMaps.map((fm, idx) => (
              <button
                key={idx}
                type="button"
                onClick={() => setSelectedFloorIndex(idx)}
                className={`border rounded p-1 relative ${selectedFloorIndex === idx ? "ring-2 ring-teal-400" : ""}`}
              >
                <ImgOptimized
                  src={getImageUrls([fm], true, true)?.[0]}
                  alt={`floor-${idx}`}
                  style={{ width: "100%", height: 80, objectFit: "cover" }}
                />
                <div className="absolute bottom-1 left-1 bg-white text-xs px-1 rounded">
                  {idx + 1}
                </div>
              </button>
            ))}
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <button
              onClick={() => {
                closePicker();
              }}
              className="border border-gray-300 hover:bg-gray-100 text-gray-700 py-1 px-3 rounded"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (selectedFloorIndex == null) return;
                const chosen = allFloorMaps[selectedFloorIndex];
                const url = getImageUrls([chosen], true, true)?.[0];
                setFloorMapUrl(url);
                closePicker();
                setIsOpen(true);
              }}
              disabled={selectedFloorIndex == null}
              className="bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded disabled:opacity-50"
            >
              Select
            </button>
          </div>
        </PopupWrapper>
      )}

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-auto flex bg-black bg-opacity-50">
          <div className="relative p-6 bg-white m-auto rounded-lg shadow-xl">
            {/* Modal header */}
            <div className="flex justify-between items-center pb-3">
              <h3 className="text-xl font-semibold">
                Select {isImageAreaSelection ? " Image " : " Key Plan "} Area
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Modal body */}
            <div className="flex flex-col h-full">
              <div className="border-2 p-4 rounded-lg mb-4">
                <div className="flex gap-3 items-center">
                  <span className="font-medium w-24">
                    Radius: {circleRadius}px
                  </span>
                  <div className="relative w-full h-2 bg-gray-200 rounded-md">
                    {/* Slider track */}
                    <div
                      className="absolute h-2 bg-teal-500 rounded-md"
                      style={{
                        width: `${((circleRadius - 10) / (isLargeArea ? 290 : 190)) * 100}%`,
                      }}
                    ></div>
                    {/* Slider thumb */}
                    <input
                      type="range"
                      min="10"
                      max={isLargeArea ? "300" : "200"}
                      value={circleRadius}
                      onChange={(e) =>
                        setCircleRadius(parseInt(e.target.value))
                      }
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                      className="absolute w-full h-2 opacity-0 cursor-pointer"
                    />
                    {/* Custom thumb */}
                    <div
                      className="absolute top-1/2 -translate-y-1/2 w-6 h-6 bg-white pointer-events-none border-2 border-teal-500 rounded-full"
                      style={{
                        left: `calc(${((circleRadius - 10) / (isLargeArea ? 290 : 190)) * 100}% - 12px)`,
                      }}
                    >
                      {/* Tooltip */}
                      {showTooltip && (
                        <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-teal-500 text-white px-2 py-1 rounded text-xs whitespace-nowrap">
                          {circleRadius}px
                          {/* Arrow */}
                          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-teal-500 rotate-45"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <p className="mt-2 text-sm text-gray-500">
                  Click anywhere on the image or drag the circle to position it
                  over the area you want to select
                </p>
              </div>

              <div
                id="floormapView"
                className="border-2 rounded-md relative bg-gray-100 flex items-center justify-center overflow-hidden"
                style={{
                  width: `${CONTAINER_WIDTH}px`,
                  height: `${CONTAINER_HEIGHT}px`,
                }}
              >
                {floorMapUrl && (
                  <>
                    <div
                      style={{
                        width: stageSize.width,
                        height: stageSize.height,
                        position: "relative",
                      }}
                    >
                      <ImgOptimized
                        ref={imageRef}
                        src={floorMapUrl}
                        alt="Floor Plan"
                        style={{
                          width: `${stageSize.width}px`,
                          height: `${stageSize.height}px`,
                          objectFit: "contain",
                        }}
                        onLoad={() => {
                          // Get original image dimensions
                          const originalWidth = imageRef.current.naturalWidth;
                          const originalHeight = imageRef.current.naturalHeight;
                          setOriginalImageSize({
                            width: originalWidth,
                            height: originalHeight,
                          });

                          // Calculate scale factors to fit image in fixed container with some padding
                          const padding = 20; // Add padding to prevent edge overflow
                          const availableWidth = CONTAINER_WIDTH - padding;
                          const availableHeight = CONTAINER_HEIGHT - padding;

                          const scaleX = availableWidth / originalWidth;
                          const scaleY = availableHeight / originalHeight;
                          const scale = Math.min(scaleX, scaleY); // Use uniform scale to maintain aspect ratio

                          // Calculate display dimensions (ensuring they fit within container)
                          const displayWidth = Math.min(
                            originalWidth * scale,
                            availableWidth,
                          );
                          const displayHeight = Math.min(
                            originalHeight * scale,
                            availableHeight,
                          );

                          setStageSize({
                            width: displayWidth,
                            height: displayHeight,
                          });
                          setScaleFactors({ x: scale, y: scale });

                          // Set initial circle position (center of scaled image)
                          setCirclePos({
                            x: displayWidth / 2,
                            y: displayHeight / 2,
                          });

                          // Set initial circle radius proportional to image size
                          setCircleRadius(
                            Math.ceil(
                              Math.min(displayWidth, displayHeight) * 0.1,
                            ),
                          );
                        }}
                      />
                    </div>
                    <Stage
                      width={stageSize.width}
                      height={stageSize.height}
                      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-black/40 cursor-crosshair"
                      onClick={handleStageClick}
                    >
                      <Layer>
                        <Circle
                          x={circlePos.x}
                          y={circlePos.y}
                          radius={circleRadius}
                          fill="rgba(0, 128, 128, 0.3)"
                          stroke="teal"
                          strokeWidth={2}
                          draggable
                          onDragStart={handleCircleDragStart}
                          onDragEnd={handleCircleDragEnd}
                        />
                      </Layer>
                    </Stage>
                  </>
                )}
              </div>
            </div>

            {/* Modal footer */}
            <div className="flex justify-end pt-4 mt-4 border-t">
              <button
                onClick={handleSaveSelection}
                className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded mr-3"
              >
                Save Selection
              </button>
              <button
                onClick={onClose}
                className="border border-gray-300 hover:bg-gray-100 text-gray-700 py-2 px-4 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloorMapUpload;
